import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export function Cartao({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return (
    <section
      className={cn('rounded-xl border border-borda bg-superficie p-5 shadow-sm', className)}
      {...props}
    />
  );
}

export function CartaoTitulo({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn('text-base font-semibold text-texto', className)} {...props} />;
}

export function CartaoDescricao({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('mt-1 text-sm text-texto-suave', className)} {...props} />;
}
